module.exports = {
  locales: ['default', 'en', 'ja', 'ko', 'th', 'vi', 'pt', 'es', 'ar', 'cn'],
  defaultLocale: 'default',
  pages: {
    '*': ['navigation', 'forms', 'homepage', 'search'],
  },
  localesToIgnore: ['default'],
}
